var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.$route.name != 'PageNotFound')?_c('AppHeader'):_vm._e(),_c('router-view',{key:_vm.$route.fullPath,staticStyle:{"min-height":"56vh"},style:(_vm.$vuetify.breakpoint.name == 'md'
              ? 'padding-top:2px'
              : _vm.$vuetify.breakpoint.name == 'xs'
              ? 'padding-top:2px'
              : _vm.$vuetify.breakpoint.name == 'sm'
              ? 'padding-top:69px'
              : '')}),(_vm.$route.name != 'PageNotFound')?_c('appFooter'):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }